function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "tv-line",
  clipPath: "url(#clip0_1988_3670)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M14.1302 4.58336H19.258C19.7603 4.58336 20.1673 4.99127 20.1673 5.50002V18.3334C20.1673 18.8394 19.7503 19.25 19.258 19.25H2.74333C2.62337 19.2498 2.50463 19.2259 2.39393 19.1796C2.28324 19.1334 2.18276 19.0657 2.09828 18.9806C2.01379 18.8954 1.94695 18.7944 1.9016 18.6833C1.85625 18.5722 1.83328 18.4533 1.834 18.3334V5.50002C1.834 4.99402 2.25108 4.58336 2.74333 4.58336H7.87117L5.5465 2.25869L6.84267 0.962524L10.4635 4.58336H11.5378L15.1587 0.962524L16.4548 2.25869L14.1302 4.58336ZM3.66733 6.41669V17.4167H18.334V6.41669H3.66733Z",
  fill: "currentColor"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1988_3670"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "currentColor"
})));
function SvgLinearTvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearTvIcon);
export default __webpack_public_path__ + "static/media/Linear TV Icon.9b02c0ff939cc99a0e68641a2cee1949.svg";
export { ForwardRef as ReactComponent };